<template>
  <div class="page">
    <pcHeaders></pcHeaders>
    <div style="min-height: 80vh">
      <div class="nav"></div>
      <div class="group_1">
        <div class="box_1">
          <div class="back">
            <div class="icon_1" @click="back"><img src="../../assets/images/Frame@2x (1).png" alt="" /></div>
            <div class="text_1" @click="back">返回首页</div>
          </div>
          <div class="content">
            <div v-if="tearchList.length > 0" style="display: flex; flex-wrap: wrap">
              <div class="list" v-for="item in tearchList" :key="item.id" @click="handleDetail(item.id)">
                <div class="info">
                  <div class="avater">
                    <img :src="item.photo" alt="" v-if="item.photo != '' && item.photo != null" />
                    <img src="../../assets/images/avater.png" alt="" v-else />
                  </div>
                  <div>
                    <div class="text_2">{{ item.realname || '' }}</div>
                    <div class="text_3">{{ item.position || '' }}</div>
                  </div>
                </div>
                <div class="desc">
                  {{ item.memo || '' }}
                </div>
              </div>
            </div>
            <div v-else style="font-size: 18px; text-align: center">暂无数据</div>
          </div>
          <el-pagination
            style="margin-top: 30px; text-align: center"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="pageNum"
            :page-sizes="[12, 24, 48, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '.././component/head.vue';
import pcBottom from '.././component/bottom.vue';
import { findTeacherList } from '@/api/study';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    // 这里存放数据
    return {
      pageSize: 12,
      pageNum: 1,
      total: 0,
      tearchList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //页码变化事件
    handleCurrentChange1(val) {
      console.log(val, 'ppp');
      this.pageNum = val;
      this.getInfo();
    },
    handleSizeChange1(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getInfo();
    },
    //返回首页
    back() {
    this.$router.push('/');
    },
    getInfo() {
      findTeacherList({ pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
        console.log(res);
        this.tearchList = res.data.rows;
        this.total = res.data.total;
      });
    },
    handleDetail(id) {
      this.$router.push({
        path: '/tearchDetail',
        query: {
          id: id
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getInfo();
    // this.messageInfo = JSON.parse(this.$route.query.data)
    // console.log(this.messageInfo);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background: #f4f6fa;
}
.nav {
  width: 100%;
  height: 250px;
  background-image: url('../../assets/images/Group 2595@2x.png');
  background-size: 100%;
}
.group_1 {
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
  .box_1 {
    background: #ffffff;
    width: 1400px;
    height: auto;
    padding: 40px;
  }
  .back {
    display: flex;
    align-items: center;
    height: 22px;
    
    img {
      width: 16px;
      height: 16px;

    }
    .icon_1 {
      width: 16px;
      height: 16px;
    cursor: pointer;

    }
    .text_1 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      margin-left: 7px;
    cursor: pointer;

    }
  }
  .content {
    width: 100%;
    margin-top: 17px;
    .list:nth-child(6n) {
      margin-right: 0 !important;
    }
    .list {
      margin-right: 21px;
      width: 200px;
      height: 240px;
      background: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
      box-shadow: 0px 5px 40px 0px rgba(65, 147, 246, 0.1);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #ffffff;
      margin-bottom: 20px;
      padding: 18px 20px 32px 20px;
      .info {
        display: flex;
        .avater {
          width: 48px;
          height: 48px;
          margin-right: 13px;
          img {
            width: 48px;
            height: 48px;
      border-radius: 50%;
            
          }
        }
        .text_2 {
          width: 80px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .text_3 {
          width: 80px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 400;
          font-size: 12px;
          color: rgba(51, 51, 51, 0.5);
          margin-top: 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .desc {
        width: 160px;
        height: 120px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-top: 15px;
        overflow: hidden;
        display: -webkit-box; /* 使用弹性盒模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 7; /* 限制显示的行数为2行 */
      }
    }
  }
}
</style>
